
<template>
	<!-- 信息框-输入框 -->
	<div class="labelInput" :style="{width:componentWidth}">
		<span :style="{color:spanColor,fontSize:spanFontSize+'px',width:spanWidth,}" class="innerSpan">
			<span style="color: red;" v-if="spanRequired">*&nbsp;</span>
			{{spanTitle}}:
		</span>
		<div class="innerP" :style="{width:inputWidth,fontSize:inputFontSize+'px',}">
			<el-tooltip placement="bottom" effect="light" :value="needShow" :manual="true">
				<div slot="content" class="setTip">{{setTip}}</div>
				<!-- 各种input -->
				<!-- 普通输入框 -->
				<el-input v-if="specilType=='normal'" :type="inputType" :placeholder="normalPlace" v-model="normalInput"
					@change="normalChange"></el-input>
				<!-- 可清空输入框 -->
				<el-input v-if="specilType=='clear'" :type="inputType" :placeholder="normalPlace" v-model="normalInput"
					@change="normalChange" clearable>
				</el-input>
				<!-- 密码输入框 -->
				<el-input v-if="specilType=='password'" :placeholder="normalPlace" v-model="passwordInput"
					@change="normalChange" show-password>
				</el-input>
				<!-- 输入数字 -->
				<el-input v-if="specilType=='number'" type="number" @input="showInput" :placeholder="normalPlace"
					v-model="normalInput" @change="normalChange" @blur="checkInput"></el-input>
				<!-- 限制字数的input -->
				<el-input v-if="specilType=='limit'" :type="inputType" :placeholder="normalPlace" v-model="normalInput"
					@change="normalChange" :maxlength="maxLimit" @blur="checkInput" show-word-limit>
				</el-input>
				<!-- 高度两格的文本域输入框 -->
				<el-input v-if="specilType=='textarea'" type="textarea" :autosize="{ minRows: 2,}"
					:placeholder="normalPlace" :maxlength="maxLimit" show-word-limit v-model="normalInput"
					@change="normalChange">
				</el-input>
			</el-tooltip>
		</div>
	</div>
</template>

<script>
	import {
		vaildte
	} from '../../utils/validate.js'
	export default {
		data() {
			return {
				//通用输入框
				normalInput: '',

				// 密码输入框
				passwordInput: '',
				needShow: false,

				// 提示
				setTip: ''
			}
		},
		props: {
			// 默认组件宽度
			componentWidth: {
				type: String,
				default: '600px'
			},
			// 控制输入类型
			inputType: {
				type: String,
				default: 'text'
			},
			// 控制输入框类型
			specilType: {
				type: String,
				default: 'normal'
			},
			// 限制框限制个数
			maxLimit: {
				type: Number,
				default: 10
			},
			// span控制类
			// 限制必填
			spanRequired: {
				default: Boolean,
				default: false
			},
			spanColor: {
				type: String,
				default: '#000'
			},
			spanFontSize: {
				type: Number,
				default: 14
			},
			spanWidth: {
				type: String,
				default: '100px'
			},
			spanTitle: {
				type: String,
				default: '标题'
			},
			// input控制类
			inputWidth: {
				type: String,
				default: 'auto'
			},
			inputFontSize: {
				type: Number,
				default: 14
			},
			normalPlace: {
				type: String,
				default: '请输入内容'
			},
			// 手机号验证
			isPhone: {
				type: Boolean,
				default: false
			},
			// 邮箱验证
			isEmail: {
				type: Boolean,
				default: false
			},
			// 是否为银行卡号
			isMoneyCard: {
				type: Boolean,
				default: false
			},
			// 绑定外部值
			outInput: {
				type: String,
				default: ''
			}
		},
		watch: {
			outInput(newvalue, oldvalue) {
				this.normalInput = newvalue
				this.$emit('inputChange', newvalue)
			}
		},
		computed: {

		},
		methods: {
			// 通用输入框事件触发
			normalChange(e) {
				if (this.isPhone || this.isEmail || this.isMoneyCard) return
				this.$emit('inputChange', e)
			},
			// 限制数字输入长度
			showInput(e) {
				if (e.length > this.maxLimit) {
					this.normalInput = e.slice(0, this.maxLimit)
				}
			},
			// 检查是否合法
			checkInput() {
				if (this.isPhone) {
					if (!vaildte.isPhone(this.normalInput)) {
						this.needShow = true
						if (!this.normalInput) {
							this.$emit('inputChange', this.normalInput)
							setTimeout(() => {
								this.needShow = false
							}, 2000)
						}
						this.setTip = "请输入正确的手机号"
					} else {
						this.$emit('inputChange', this.normalInput)
						this.needShow = false
					}
				}
				if (this.isEmail) {
					if (!vaildte.isEmail(this.normalInput)) {
						this.needShow = true
						if (!this.normalInput) {
							this.$emit('inputChange', this.normalInput)
							setTimeout(() => {
								this.needShow = false
							}, 2000)
						}
						this.setTip = "请输入正确的电子邮箱"
					} else {
						this.$emit('inputChange', this.normalInput)
						this.needShow = false
					}
				}
				if (this.isMoneyCard) {
					if (!vaildte.isMoneyCard(this.normalInput)) {
						this.needShow = true
						if (!this.normalInput) {
							this.$emit('inputChange', this.normalInput)
							setTimeout(() => {
								this.needShow = false
							}, 2000)
						}
						this.setTip = "请输入正确的银行卡号"
					} else {
						this.$emit('inputChange', this.normalInput)
						this.needShow = false
					}
				}
			}
		}
	}
</script>

<style>
	.setTip {
		color: red;
	}

	.el-tooltip__popper.is-light {
		border: 1px solid red;
	}

	.labelInput {
		display: flex;
		align-items: center;
		justify-content: flex-start;
		min-height: 40px;
		/* line-height: 40px; */
		box-sizing: border-box;
		margin: 10px 10px;
	}

	.innerSpan {
		display: inline-block;
		/*display: inherit;*/
		justify-content: flex-end;
		text-align: left;
	}

	.innerP {
		display: inline-block;
		display: inherit;
		justify-content: flex-start;
		padding-left: 20px;
		flex: 1;
	}

	input::-webkit-outer-spin-button,
	input::-webkit-inner-spin-button {
		-webkit-appearance: none;
	}

	input[type="number"] {
		-moz-appearance: textfield;
	}
</style>
